module.exports = __webpack_public_path__ + "img/svg/background-footer.9572b714b6d84b7b1d0314db92d154ad.svg";